import { render, staticRenderFns } from "./rewardCallbackEdit.vue?vue&type=template&id=5b914fc2&scoped=true&"
import script from "./rewardCallbackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCallbackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b914fc2",
  null
  
)

export default component.exports